export class SearchOptions {

	blacklist: string[] = [
		"WY",
		"Wyoming"
	];
	minimumLength: number = 3;
}
